// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Abxo","index":"styles_index__30Ltn"};